import type { ClientConfig } from "@/features/client-config/types/client-config";
import type { SystemConfigFetchResult } from "@/features/radar/types/system-config-fetch-result";

import { convertCourseData } from "./convert-course-data";

export const mergeFetchedSystemConfigs = (
  currentConfig: ClientConfig,
  fetchedByRadarId: Map<string, SystemConfigFetchResult>
): ClientConfig => ({
  ...currentConfig,
  radars: currentConfig.radars.map((radar) => {
    const fetchResult = fetchedByRadarId.get(radar.id);
    if (fetchResult?.status !== "ok") {
      return radar;
    }
    const { config: systemConfig } = fetchResult;
    const convertedCourseData = convertCourseData(
      systemConfig,
      radar.selectedLaunchAreaIds
    );
    return {
      ...radar,
      systemConfig,
      ...(convertedCourseData && { convertedCourseData }),
    };
  }),
});
